import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PartyPopperIcon, CalendarIcon, UsersIcon, DollarSignIcon, ImageIcon, ArrowRightIcon, FileTextIcon, XIcon, CheckCircleIcon } from 'lucide-react';
const AnniversaryManager = () => {
  const navigate = useNavigate();
  // Modals
  const [isRegistrationsOpen, setIsRegistrationsOpen] = useState(false);
  const [isProgrammeOpen, setIsProgrammeOpen] = useState(false);
  const [isDonationsOpen, setIsDonationsOpen] = useState(false);
  const registrations = [{
    name: 'Dr. Oluwasegun Adeyemi',
    set: 'Class of 2000',
    type: 'Sponsor',
    time: '10 mins ago',
    email: 'olu@example.com'
  }, {
    name: 'Mrs. Folashade Ojo',
    set: 'Class of 1985',
    type: 'Attendee',
    time: '1 hour ago',
    email: 'fola@example.com'
  }, {
    name: 'Engr. Tunde Bakare',
    set: 'Class of 1992',
    type: 'Volunteer',
    time: '3 hours ago',
    email: 'tunde@example.com'
  }, {
    name: 'Chief Amina Bello',
    set: 'Class of 1978',
    type: 'Sponsor',
    time: '5 hours ago',
    email: 'amina@example.com'
  }, {
    name: 'Mr. Samuel Peters',
    set: 'Class of 2010',
    type: 'Attendee',
    time: '1 day ago',
    email: 'sam@example.com'
  }];
  const donations = [{
    name: 'Class of 1985',
    amount: '₦5,000,000',
    project: 'Library Renovation',
    date: 'Feb 15, 2026'
  }, {
    name: 'Dr. Oluwasegun Adeyemi',
    amount: '₦1,000,000',
    project: 'General Fund',
    date: 'Feb 18, 2026'
  }, {
    name: 'Anonymous Alumni',
    amount: '₦500,000',
    project: 'Science Lab',
    date: 'Feb 19, 2026'
  }, {
    name: 'Class of 1992',
    amount: '₦2,500,000',
    project: 'Sports Complex',
    date: 'Feb 20, 2026'
  }];
  const programme = [{
    day: 'Day 1 (Mon)',
    event: 'Jumat Service & Rally',
    time: '10:00 AM'
  }, {
    day: 'Day 2 (Tue)',
    event: 'Inter-House Sports',
    time: '09:00 AM'
  }, {
    day: 'Day 3 (Wed)',
    event: 'Career Talk & Mentorship',
    time: '11:00 AM'
  }, {
    day: 'Day 4 (Thu)',
    event: 'Project Commissioning',
    time: '12:00 PM'
  }, {
    day: 'Day 5 (Fri)',
    event: 'Gala Night & Awards',
    time: '06:00 PM'
  }];
  return <div className="space-y-6 animate-fadeIn relative" data-id="element-1870">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-1871">
        <div data-id="element-1872">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-1873">
            70th Anniversary Hub
          </h1>
          <p className="text-sm text-gray-500" data-id="element-1874">
            Central command for all Platinum Jubilee celebrations.
          </p>
        </div>
        <button onClick={() => window.open('/anniversary', '_blank')} className="inline-flex items-center px-4 py-2 bg-yellow-500 text-blue-950 rounded-lg text-sm font-bold hover:bg-yellow-400 shadow-sm transition-colors" data-id="element-1875">
          View Live Page <ArrowRightIcon size={16} className="ml-2" data-id="element-1876" />
        </button>
      </div>

      {/* Quick Stats */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1877">
        <div className="bg-gradient-to-br from-blue-900 to-blue-950 rounded-xl p-5 text-white shadow-md" data-id="element-1878">
          <div className="flex justify-between items-start mb-4" data-id="element-1879">
            <div className="p-2 bg-white/10 rounded-lg" data-id="element-1880">
              <UsersIcon size={20} className="text-yellow-400" data-id="element-1881" />
            </div>
            <span className="text-xs font-medium bg-white/20 px-2 py-1 rounded-full" data-id="element-1882">
              +45 today
            </span>
          </div>
          <h3 className="text-3xl font-bold mb-1" data-id="element-1883">1,240</h3>
          <p className="text-sm text-blue-200" data-id="element-1884">Event Registrations</p>
        </div>

        <div className="bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-xl p-5 text-blue-950 shadow-md" data-id="element-1885">
          <div className="flex justify-between items-start mb-4" data-id="element-1886">
            <div className="p-2 bg-blue-950/10 rounded-lg" data-id="element-1887">
              <DollarSignIcon size={20} className="text-blue-950" data-id="element-1888" />
            </div>
            <span className="text-xs font-bold bg-blue-950/10 px-2 py-1 rounded-full" data-id="element-1889">
              75% of goal
            </span>
          </div>
          <h3 className="text-3xl font-bold mb-1" data-id="element-1890">₦15.4M</h3>
          <p className="text-sm font-medium" data-id="element-1891">Donations Raised</p>
        </div>

        <div className="bg-white rounded-xl p-5 border border-gray-200 shadow-sm" data-id="element-1892">
          <div className="flex justify-between items-start mb-4" data-id="element-1893">
            <div className="p-2 bg-blue-50 rounded-lg" data-id="element-1894">
              <CalendarIcon size={20} className="text-blue-600" data-id="element-1895" />
            </div>
          </div>
          <h3 className="text-3xl font-bold text-gray-900 mb-1" data-id="element-1896">5</h3>
          <p className="text-sm text-gray-500" data-id="element-1897">Scheduled Events</p>
        </div>

        <div className="bg-white rounded-xl p-5 border border-gray-200 shadow-sm" data-id="element-1898">
          <div className="flex justify-between items-start mb-4" data-id="element-1899">
            <div className="p-2 bg-purple-50 rounded-lg" data-id="element-1900">
              <ImageIcon size={20} className="text-purple-600" data-id="element-1901" />
            </div>
          </div>
          <h3 className="text-3xl font-bold text-gray-900 mb-1" data-id="element-1902">45</h3>
          <p className="text-sm text-gray-500" data-id="element-1903">Gallery Memories</p>
        </div>
      </div>

      {/* Modules */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1904">
        {/* Registrations */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6" data-id="element-1905">
          <div className="flex items-center justify-between mb-6" data-id="element-1906">
            <h2 className="text-lg font-bold text-gray-900 flex items-center gap-2" data-id="element-1907">
              <UsersIcon size={20} className="text-blue-600" data-id="element-1908" />
              Recent Registrations
            </h2>
            <button onClick={() => setIsRegistrationsOpen(true)} className="text-sm text-blue-600 font-medium hover:underline" data-id="element-1909">
              View All
            </button>
          </div>
          <div className="space-y-4" data-id="element-1910">
            {registrations.slice(0, 3).map((reg, i) => <div key={i} className="flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg border border-transparent hover:border-gray-100 transition-colors" data-id="element-1911">
                <div data-id="element-1912">
                  <p className="font-medium text-gray-900 text-sm" data-id="element-1913">
                    {reg.name}
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-1914">{reg.set}</p>
                </div>
                <div className="text-right" data-id="element-1915">
                  <span className={`inline-block px-2 py-1 text-xs rounded-md font-medium mb-1 ${reg.type === 'Sponsor' ? 'bg-purple-50 text-purple-700' : reg.type === 'Volunteer' ? 'bg-green-50 text-green-700' : 'bg-blue-50 text-blue-700'}`} data-id="element-1916">
                    {reg.type}
                  </span>
                  <p className="text-xs text-gray-400" data-id="element-1917">{reg.time}</p>
                </div>
              </div>)}
          </div>
        </div>

        {/* Content Management */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6" data-id="element-1918">
          <h2 className="text-lg font-bold text-gray-900 mb-6 flex items-center gap-2" data-id="element-1919">
            <PartyPopperIcon size={20} className="text-yellow-500" data-id="element-1920" />
            Anniversary Content
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1921">
            <button onClick={() => setIsProgrammeOpen(true)} className="p-4 border border-gray-200 rounded-xl text-left hover:border-blue-500 hover:bg-blue-50 transition-all group" data-id="element-1922">
              <CalendarIcon className="text-gray-400 group-hover:text-blue-600 mb-3" size={24} data-id="element-1923" />
              <h3 className="font-bold text-gray-900 group-hover:text-blue-700" data-id="element-1924">
                Programme
              </h3>
              <p className="text-xs text-gray-500 mt-1" data-id="element-1925">
                Edit the week-long event schedule
              </p>
            </button>
            <button onClick={() => navigate('/admin/media')} className="p-4 border border-gray-200 rounded-xl text-left hover:border-blue-500 hover:bg-blue-50 transition-all group" data-id="element-1926">
              <ImageIcon className="text-gray-400 group-hover:text-blue-600 mb-3" size={24} data-id="element-1927" />
              <h3 className="font-bold text-gray-900 group-hover:text-blue-700" data-id="element-1928">
                Gallery
              </h3>
              <p className="text-xs text-gray-500 mt-1" data-id="element-1929">
                Manage historical & recent photos
              </p>
            </button>
            <button onClick={() => navigate('/admin/content')} className="p-4 border border-gray-200 rounded-xl text-left hover:border-blue-500 hover:bg-blue-50 transition-all group" data-id="element-1930">
              <FileTextIcon className="text-gray-400 group-hover:text-blue-600 mb-3" size={24} data-id="element-1931" />
              <h3 className="font-bold text-gray-900 group-hover:text-blue-700" data-id="element-1932">
                News Updates
              </h3>
              <p className="text-xs text-gray-500 mt-1" data-id="element-1933">
                Post anniversary announcements
              </p>
            </button>
            <button onClick={() => setIsDonationsOpen(true)} className="p-4 border border-gray-200 rounded-xl text-left hover:border-blue-500 hover:bg-blue-50 transition-all group" data-id="element-1934">
              <DollarSignIcon className="text-gray-400 group-hover:text-blue-600 mb-3" size={24} data-id="element-1935" />
              <h3 className="font-bold text-gray-900 group-hover:text-blue-700" data-id="element-1936">
                Donations
              </h3>
              <p className="text-xs text-gray-500 mt-1" data-id="element-1937">
                Track legacy project funding
              </p>
            </button>
          </div>
        </div>
      </div>

      {/* Modals */}

      {/* Registrations Modal */}
      {isRegistrationsOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-fadeIn" data-id="element-1938">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-3xl max-h-[90vh] flex flex-col overflow-hidden" data-id="element-1939">
            <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-1940">
              <h2 className="text-xl font-bold text-gray-900" data-id="element-1941">
                All Registrations
              </h2>
              <button onClick={() => setIsRegistrationsOpen(false)} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-1942">
                <XIcon size={24} data-id="element-1943" />
              </button>
            </div>
            <div className="flex-1 overflow-y-auto p-0" data-id="element-1944">
              <table className="min-w-full divide-y divide-gray-200" data-id="element-1945">
                <thead className="bg-gray-50 sticky top-0" data-id="element-1946">
                  <tr data-id="element-1947">
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-1948">
                      Name
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-1949">
                      Class Set
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-1950">
                      Type
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-1951">
                      Email
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200" data-id="element-1952">
                  {registrations.map((reg, i) => <tr key={i} className="hover:bg-gray-50" data-id="element-1953">
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1954">
                        {reg.name}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1955">
                        {reg.set}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-1956">
                        <span className={`inline-flex px-2 py-1 text-xs rounded-md font-medium ${reg.type === 'Sponsor' ? 'bg-purple-50 text-purple-700' : reg.type === 'Volunteer' ? 'bg-green-50 text-green-700' : 'bg-blue-50 text-blue-700'}`} data-id="element-1957">
                          {reg.type}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1958">
                        {reg.email}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </div>}

      {/* Programme Modal */}
      {isProgrammeOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-fadeIn" data-id="element-1959">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-2xl max-h-[90vh] flex flex-col overflow-hidden" data-id="element-1960">
            <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-1961">
              <h2 className="text-xl font-bold text-gray-900" data-id="element-1962">
                Event Programme
              </h2>
              <button onClick={() => setIsProgrammeOpen(false)} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-1963">
                <XIcon size={24} data-id="element-1964" />
              </button>
            </div>
            <div className="flex-1 overflow-y-auto p-6" data-id="element-1965">
              <div className="space-y-4" data-id="element-1966">
                {programme.map((prog, i) => <div key={i} className="flex items-center gap-4 p-4 border border-gray-200 rounded-lg" data-id="element-1967">
                    <div className="w-24 flex-shrink-0 font-bold text-blue-900" data-id="element-1968">
                      {prog.day}
                    </div>
                    <div className="flex-1" data-id="element-1969">
                      <input type="text" defaultValue={prog.event} className="w-full px-3 py-1.5 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 outline-none" data-id="element-1970" />
                    </div>
                    <div className="w-32 flex-shrink-0" data-id="element-1971">
                      <input type="text" defaultValue={prog.time} className="w-full px-3 py-1.5 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 outline-none" data-id="element-1972" />
                    </div>
                  </div>)}
              </div>
            </div>
            <div className="p-6 border-t border-gray-100 bg-gray-50 flex justify-end gap-3" data-id="element-1973">
              <button onClick={() => setIsProgrammeOpen(false)} className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-100" data-id="element-1974">
                Cancel
              </button>
              <button onClick={() => setIsProgrammeOpen(false)} className="px-4 py-2 bg-blue-950 text-yellow-400 rounded-lg text-sm font-medium hover:bg-blue-900" data-id="element-1975">
                Save Schedule
              </button>
            </div>
          </div>
        </div>}

      {/* Donations Modal */}
      {isDonationsOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-fadeIn" data-id="element-1976">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-3xl max-h-[90vh] flex flex-col overflow-hidden" data-id="element-1977">
            <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-1978">
              <h2 className="text-xl font-bold text-gray-900" data-id="element-1979">
                Donation Tracker
              </h2>
              <button onClick={() => setIsDonationsOpen(false)} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-1980">
                <XIcon size={24} data-id="element-1981" />
              </button>
            </div>
            <div className="flex-1 overflow-y-auto p-0" data-id="element-1982">
              <table className="min-w-full divide-y divide-gray-200" data-id="element-1983">
                <thead className="bg-gray-50 sticky top-0" data-id="element-1984">
                  <tr data-id="element-1985">
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-1986">
                      Donor / Group
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-1987">
                      Amount
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-1988">
                      Designated Project
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-1989">
                      Date
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200" data-id="element-1990">
                  {donations.map((don, i) => <tr key={i} className="hover:bg-gray-50" data-id="element-1991">
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1992">
                        {don.name}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-bold text-green-600" data-id="element-1993">
                        {don.amount}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1994">
                        {don.project}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1995">
                        {don.date}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </div>}
    </div>;
};
export default AnniversaryManager;